<template>
  <div>
    <header-menu class="dissa" />
    <transition :name="transtype" mode="out-in">
      <div
        class="hello" v-bind:class="{ firstcil: index === 0 }"
        v-for="data, index in contentData.videos"
        v-if="index === parseInt(vidnr)" 
        :key="index"
      >
        <split-vid
          :firstsmall="data['film_liten_fore']"
          :secondsmall="data['film_liten_efter']" 
          :first="data['film_stor_fore']"
          :second="data['film_stor_efter']" 
          :firstback="data['bakgrundsbild_fore']"
          :secondback="data['bakgrundsbild_efter']"
          :datum="data['datum']"
          :vimeo-id="data['vimeo_id']"
          :is-ios="isIos"
          :text="data['info_text_short']"
        />
        <framer bordersize="small" class="move-left dissa" @click.native="moveLeft"><</framer>
        <framer bordersize="small" class="move-right dissa" @click.native="moveRight">></framer>
        <br>
        <div class="what dissa" v-on:click="toggleInfo(index)">
          <framer bordersize="small" class="extra" v-if="showinfo !== index" >?</framer>
          <div class="what-open" >
            <framer bordersize="large" v-if="showinfo === index">
              <div class="close" v-on:click.stop="toggleInfo(index)">&#10005;</div>
              <div v-html="data['info_text']"></div>
            </framer>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Framer from '@/components/Framer'
import SplitVid from '@/components/SplitVid'
import HeaderMenu from '@/components/HeaderMenu'
export default {
  name: 'HelloWorld',
  data () {
    return {
      onAMovie: false,
      msg: 'OnceNature',
      showinfo: false,
      contentData: [],
      vidnr: 0,
      transtype: 'list',
      isIos: false
    }
  },
  props: ['videonr'],
  computed: {
  },
  methods: {
    toggleInfo (nr) {
      if (nr === this.showinfo) {
        this.showinfo = false
      } else {
        this.showinfo = nr
      }
    },
    moveRight () {
      this.transtype = 'list'
      this.vidnr++
      //  console.log('moveright', this.vidnr)
      if (this.vidnr > 5) {
        this.vidnr = 0
      }
    },
    moveLeft () {
      this.transtype = 'list2'
      //  console.log('moveleft')
      this.vidnr--
      if (this.vidnr < 0) {
        this.vidnr = 5
      }
    }
  },
  beforeMount () {
    if (this.videonr) {
      this.vidnr = this.videonr - 1
    }
    var userAgent = window.navigator.userAgent
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      this.isIos = true
    }
  },
  mounted () {
    //  console.log('videonr: ', this.videonr)
    this.contentData = window.content()
    //  console.log(window.content())
    console.log('version', '1.1.0')
  },
  components: { SplitVid, HeaderMenu, Framer }
}
</script>
<style>
  a {
    color: #222;
  }
  a:hover {
    color: #000;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .extra {
    padding-top: 20px;
  }
  .move-left, .move-right {
    font-size: 36px;
    font-weight: bold;
    display: inline-block;
    position: relative;
    cursor: pointer;
    height: 70px;
    min-height: 70px;
    width: 70px;
    position: absolute;
    top: 0px;
    line-height: 35px;
    left: calc(50% - 450px);
    top: 50%;
    box-sizing: border-box;
    overflow: visible;
    text-shadow: 1px 1px 1px #fff, -1px -1px 1px #000;
  }
  .move-right {
    left: auto;
    right: calc(50% - 450px);
  }
  .what {
    font-size: 36px;
    font-weight: bold;
    display: inline-block;
    position: relative;
    height: 70px;
    width: 70px;
    position: absolute;
    top: calc(70% + 70px);
    box-sizing: border-box;
    overflow: visible;
    cursor: pointer;
    text-shadow: 0.5px 0.5px 0.5px #fff, -0.5px -0.5px 0.5px #000;
  }
  .what-open {
    width: 420px;
    font-weight: normal;
    height: auto;
    position: absolute;
    left: -175px;
    background-color: #fff;
    font-size: 18px;
    text-align: left;
    z-index: 99999999;
  }
  .close {
    text-align: center;
    cursor: pointer;
    padding: 10px;
    padding-top: 0px;
  }
  .close:hover {
    opacity: 0.6;
  }
  .info {
    position: relative;
    display: inline-block;
    width: 100px;
    height: 60px;
    font-size: 20px;
  }
  .hello {
    height: 100vh;
    width: 100vw;
    margin: auto;
    min-height: 990px; 
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
  }
  .hello.firstcil {
    min-height: 990px;    
  }
  .list-enter-active, .list-leave-active {
    transition: all 0.4s linear;
  }
  .list-enter {
    opacity: 0;
    transform: translateX(90%);
  }
  .list-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(-90%);
  }

  .list2-enter-active, .list2-leave-active {
    transition: all 0.4s linear;
  }
  .list2-enter {
    opacity: 0;
    transform: translateX(-80%);
  }
  .list2-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(80%);
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue